import ConditionalRender from "../../../ConditionalRender"
import { AnInputBox } from "../../input_utils/AnInput"
import { CONDITIONS } from "./MapperFilters/MapperSuggestionUtils"

export const CommonRangeFilter = ({ 
    range_filter, 
    setRangeFilter, 
    conditions = CONDITIONS, 
    minRange, 
    maxRange,
    layout = 'default',
    customLabel = 'Condition',
    ...props 
}) => {
    const handleConditionChange = (cond) => {
        let new_range_filter = { ...range_filter }
        new_range_filter.cond = cond
        new_range_filter.min = new_range_filter.max = '';
        setRangeFilter( new_range_filter )
    }
    const handleMinChange = (new_value) => {
        let new_range_filter = {...range_filter}
        switch (new_range_filter.cond) {
            case "Above": {
                new_range_filter.min = new_value
                new_range_filter.max = maxRange
                break;
            }
            case "Below": {
                new_range_filter.min = minRange
                new_range_filter.max = new_value
                break;
            }
            case "Between": {
                new_range_filter.min = new_value
                new_range_filter.max = new_range_filter.max
                break;
            }
            case "Equal": {
                new_range_filter.min = new_value
                new_range_filter.max = new_value
                break;
            }
        }
        setRangeFilter(new_range_filter)
    }
    const handleMaxChange = (value) => {
        let new_range_filter = { ...range_filter }
        new_range_filter.max = value
        setRangeFilter(new_range_filter)
    }

    if(layout === 'Horizontal') 
    return (
        <div style={{display: 'flex', alignItems: 'flex-start'}}>
            <AnInputBox label={customLabel} style={{ maxWidth: "162px", width: '100%' }}>
                <select placeholder="Above" value={range_filter.cond} onChange={(e) => handleConditionChange(e.target.value)}>
                    {
                        conditions.map(condition => (
                            <option key={condition.key} value={condition.key}>
                                {condition.label}
                            </option>
                        ))
                    }
                </select>
            </AnInputBox>
            <div className='default_flex_container' style={{marginLeft: 16, paddingTop: 20}}>
                <div>
                    <AnInputBox label={""} style={{ maxWidth: "60px", width: '100%' }}>
                        <input type="text" id="min" value={range_filter.cond === 'Below' ? range_filter.max : range_filter.min} onChange={(e) =>
                            handleMinChange(e.target.value)
                        } placeholder={range_filter.cond === 'Between' ? 'From' : '50'} />
                    </AnInputBox>
                </div>
                <div>
                    <ConditionalRender if={range_filter.cond === 'Between'}>
                        <div className='default_flex_container'>
                            <div className='text_body_light' style={{ padding: '0px 6px' }}>-</div>
                            <AnInputBox label={""} style={{ maxWidth: "60px", width: '100%' }}>
                                <input type="text" id="max" value={range_filter.max} onChange={(e) => handleMaxChange(e.target.value)} placeholder='To' />
                            </AnInputBox>
                        </div>
                    </ConditionalRender>
                </div>
            </div>
        </div>
    )
    else
    return (
        <div>
        <AnInputBox label={customLabel} style={{ maxWidth: "106px" }}>
            <select placeholder="Above" value={range_filter.cond} onChange={(e) => handleConditionChange(e.target.value)}>
                {
                    conditions.map(condition => (
                        <option key={condition.key} value={condition.key}>
                            {condition.label}
                        </option>
                    ))
                }
            </select>
        </AnInputBox>
        <div className='default_flex_container'>
            <div>
                <AnInputBox label={"Value"} style={{ maxWidth: "144px" }}>
                    <input type="text" id="value" value={range_filter.cond === 'Below' ? range_filter.max : range_filter.min} onChange={(e) =>
                        handleMinChange(e.target.value)
                    } placeholder={range_filter.cond === 'Between' ? 'From' : '50'} />
                </AnInputBox>
            </div>
            <div>
                <ConditionalRender if={range_filter.cond === 'Between'}>
                    <div className='default_flex_container' style={{ paddingTop: 20 }}>
                        <div className='text_body_light' style={{ padding: '0px 6px' }}>-</div>
                        <AnInputBox label={""} style={{ maxWidth: "144px" }}>
                            <input type="text" id="value" value={range_filter.max} onChange={(e) => handleMaxChange(e.target.value)} placeholder='To' />
                        </AnInputBox>
                    </div>
                </ConditionalRender>
            </div>
        </div>
    </div>
    )
}